import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import CustomDataGrid from '../../../../../../shared/components/CustomDataGrid';
import { handleError } from '../../../../../../shared/functions/handleError';
import { usePagination } from '../../../../../../shared/hooks/usePagination';
import { useLeaveDaysColumns } from '../../../../../../shared/hooks/useLeaveDaysColumns';
import { ILeaveDay } from '../../../../../../shared/interfaces/leave-days/ILeaveDay';
import { AdminLeaveDaysService } from '../../../../leave-days/service';

const LeaveDaysTab = () => {
  const { id } = useParams();
  const [data, setData] = useState<ILeaveDay[] | undefined>(undefined);
  const {
    pagination,
    setCount,
    totalPages,
    setTotalPages,
    count,
    setPagination,
  } = usePagination({
    perPage: 5,
  });
  const columns = useLeaveDaysColumns(
    () => {},
    () => {},
    () => {},
    true,
  );

  useEffect(() => {
    !!id &&
      AdminLeaveDaysService.get({
        ...pagination,
        page: pagination?.page + 1,
        userId: id,
      })
        .then((response) => {
          setCount(response?.count);
          setTotalPages(Math.ceil(response?.count / pagination?.perPage));
          setData(response.data);
        })
        .catch(handleError);
  }, [pagination, setTotalPages, setCount, id]);
  return (
    <CustomDataGrid
      hasNextPage={totalPages < pagination?.page}
      rows={data || []}
      columns={columns}
      rowCount={count}
      pagination={pagination}
      setPagination={setPagination}
      loading={data === undefined}
    />
  );
};

export default LeaveDaysTab;
